import { css } from 'styled-components';
/**
 * Shared styled-components css block for text field appearance.
 *
 * @deprecated Do not use in new code. This package exists only to support legacy non-nx
 * components (text-field.tsx, text-area.tsx) until they are ported to nx.
 */
export const TextFieldStyling = css `
    text-align: ${props => props.textAlign};
    border-radius: 4px;
    font-size: ${props => props.theme.fontConfiguration.sizes.Caption};
    padding: 8px;
    border-color: ${props => props.theme.borderConfiguration.defaultColor};
    transition:
        box-shadow 0.5s,
        border-color 0.15s ease-out;
    color: ${props => props.theme.text};

    &:hover {
        border-color: ${props => props.theme.borderConfiguration.hover};
    }

    &:focus,
    &:active {
        border-color: ${props => props.theme.borderConfiguration.focus};
    }

    &::placeholder {
        color: ${props => props.theme.textDisabled};
    }

    &:disabled {
        border-color: transparent;
        background-color: ${props => props.theme.borderConfiguration.disabled};
        color: ${props => props.theme.textDisabled};
    }

    ${props => props.ispassive
    ? css `
                  && {
                      border-color: transparent;
                      background: transparent;
                      padding-left: 0;
                      color: ${props => props.theme.text};
                      -webkit-text-fill-color: ${props => props.theme.text};
                      opacity: 1;
                  }
              `
    : ''}
`;
